import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import * as S from './SiderMenu.styles';
import { getSidebarNavigation } from '../sidebarNavigation'; // Import the updated function
import { MenuProps } from 'antd';

interface SiderContentProps {
  setCollapsed: (isCollapsed: boolean) => void;
}

const SiderMenu: React.FC<SiderContentProps> = ({ setCollapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState('');

  // Dynamically generate sidebar navigation items based on permissions
  const sidebarNavigation = getSidebarNavigation();

  // Flatten the navigation items for selected and open keys
  const sidebarNavFlat = sidebarNavigation.reduce(
    (result: any[], current) =>
      result.concat(current.children && current.children.length > 0 ? current.children : current),
    [],
  );

  const currentMenuItem = sidebarNavFlat.find(({ url }) => url === location.pathname);
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : [];

  const openedSubmenu = sidebarNavigation.find(({ children }) =>
    children?.some(({ url }) => url === location.pathname),
  );
  const defaultOpenKeys = openedSubmenu ? [openedSubmenu.key] : [];

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    //setSelectedKey(e.key);
    setCollapsed(true);
    setSelectedKey(e.key);
  };

  return (
    <S.Menu
      mode="inline"
      defaultSelectedKeys={defaultSelectedKeys}
      defaultOpenKeys={defaultOpenKeys}
      onClick={handleMenuClick}
      items={sidebarNavigation
        .filter((nav) => nav.show !== false) // Filter top-level items by `show`
        .map((nav) => {
          const isSubMenu = nav.children?.length;

          return {
            key: nav.key,
            title: t(nav.title),
            label: isSubMenu ? t(nav.title) : <Link to={nav.url || ''}>{t(nav.title)}</Link>,
            icon: selectedKey === nav.key ? nav.selectedIcon : nav.icon,
            children:
              isSubMenu &&
              nav.children
                ?.filter((childNav) => childNav.show !== false) // Filter children by `show`
                .map((childNav) => ({
                  key: childNav.key,
                  label: <Link to={childNav.url || ''}>{t(childNav.title)}</Link>,
                  title: t(childNav.title),
                })),
          };
        })}
    />
  );
};

export default SiderMenu;
